<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.sample_search_tips') ||
                  '样品款号/名称(中/英文) 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        ref="form"
        size="small"
        :model="form"
        label-width="100px"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_sampleSource') || '样品来源'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.sample_tips_select_sampleSource') ||
                    '请选择样品来源'
                "
                size="small"
                clearable
                filterable
                v-model="form.sampleSource"
                :body="{ dictType: 'sampleSource' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_business_name') || '业务人员'"
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_designer') || '设计师'">
              <dict-select
                clearable
                v-model="form.designerCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_designer') ||
                    '请选择设计师'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_sample_name') || '样品名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="
                  $l('INDEX.sample_tips_input_sampleName') || '请输入样品名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_factory') || '成品工厂'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.sample_tips_select_factory') || '请选择成品工厂'
                "
                size="small"
                clearable
                multiple
                filterable
                v-model="form.scmCodeList"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.sample_label_factory_product_number') ||
                  '工厂产品编号'
              "
            >
              <el-input
                v-model.trim="form.scmProductNo"
                :placeholder="
                  $l('INDEX.sample_tips_input_factory_product_number') ||
                    '请输入工厂产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.label_customer') || '客户'"
            >
              <dict-select
                clearable
                filterable
                multiple
                v-model="form.custCodeList"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.form_label_brand') || '品牌'"
            >
              <dict-select
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_customerItemNo') || '客人产品编号'"
            >
              <el-input
                v-model="form.customerProductNo"
                :placeholder="
                  $l('INDEX.sample_tips_input_customerProductNo') ||
                    '请输入客人产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.sample_label_quotation_method') || '报价方式'"
              prop="quotedMethod"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.quotedMethod"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="
                  $l('INDEX.sample_tips_select_quotation_method') ||
                    '请选择报价方式'
                "
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.sample_label_productLine') || '产品线'"
              >
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.sample_tips_select_productLine') ||
                        '请选择产品线'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.productLine"
                    :body="productLineParams"
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.sample_tips_select_1_category') ||
                        '请选择1级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.masterCategoryCode"
                    :body="queryMasterCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('INDEX.sample_tips_select_2_category') ||
                        '请选择2级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.categoryCode"
                    :body="queryCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  sampleStatusList: ['Y','S']
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      productLineParams: { dictType: 'productLine' },
      queryMasterCategoryParams: { parentCode: 'x' },
      queryCategoryParams: { parentCode: 'x' }
    }
  },
  watch: {
    // 查询条件下拉
    'form.productLine'() {
      this.form.masterCategoryCode = ''
      this.form.categoryCode = ''
      this.queryCategoryParams = { parentCode: '' }
      this.queryMasterCategoryParams = { parentCode: this.form.productLine }
    },
    'form.masterCategoryCode'() {
      this.form.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.form.masterCategoryCode
      }
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const params = {
        ...this.form
      }
      this.$emit('query', params)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
